

export var PersistService = (function () {
    var id = (new Date()).getTime();
    var url = process.env.REACT_APP_API_ENDPOINT + "/rest/proeve";

    //private methods


    function getId() {
        return id;
    }

    function getKlassePartier(proeveId, passord) {
        return new Promise((resolve, reject)=>{
            window.fetch(url + `/${proeveId}/partier` ,{
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    clientVersion: "3.1",
                    password: passord
                })
            })
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 0) {
                            throw Error("Tjek om du er på internettet og prøv igen");
                        }
                        else if (response.status === 401) {
                            throw Error("Ugyldig prøveid(REFNR) eller password");
                        }
                        else if (response.status === 423) {
                            throw Error("Prøven er ikke åbnet for brug av Lydighed program. Åbnes ved å sette ring passord i Prøve systemet.");
                        }
                        else if (response.status === 500) {
                            return response.json() // return the result of the inner promise, which is an error
                                .then((json) => {
                                    throw new Error(json);
                                });
                        }
                        else {
                            throw Error("Det er sket en fejl. Prøv igen.");
                        }
                    }
                    else {
                        return response.json().then(resolve)
                    }
                })
                .catch(reject);
        });
    }

    function changeKlasseParti(partiData, katalogNr, lnr, nyPartiId) {
        return new Promise((resolve, reject)=>{
            var ret = url + '/' + partiData.proeveId + '/parti/' + partiData.partiId + '/changeKlasseParti';
            window.fetch(ret, {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'parti-token': partiData.token
                },
                body: JSON.stringify({
                    'partiId'   : partiData.partiId,
                    'proeveId'  : partiData.proeveId,
                    'lnr'       : lnr,
                    'katalogNr' : katalogNr,
                    'nyPartiId' : nyPartiId})
            })

                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 0) {
                            throw Error("Tjek om du er på internettet og prøv igen");
                        }
                        else if (response.status === 500) {
                            return response.json() // return the result of the inner promise, which is an error
                                .then((json) => {
                                    throw new Error(json);
                                });
                        }
                        else {
                            throw Error("Det er sket en fejl. Prøv igen.");
                        }
                    }
                })
                .then(resolve)
                .catch(reject);
        });
    }

    function checkInToServer(partiData) {
        return new Promise((resolve, reject)=>{
            window.fetch(url + '/' + partiData.proeveId + '/parti/' + partiData.partiId + '/checkIn' ,{
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'parti-token': partiData.token
                }
            })

                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 0) {
                            throw Error("Tjek om du er på internettet og prøv igen");
                        }
                        else if (response.status === 500) {
                            return response.json() // return the result of the inner promise, which is an error
                                .then((json) => {
                                    throw new Error(json);
                                });
                        }
                        else {
                            throw Error("Det er sket en fejl. Prøv igen.");
                        }
                    }
                })
                .then(resolve)
                .catch(reject);
        });
    }

    function checkOutUnderKlasseParti(partiData, underKlassePartiId) {
        return new Promise((resolve, reject)=>{
            window.fetch(url + '/' + partiData.proeveId + '/parti/' + partiData.partiId + '/checkOutUnderKlasseParti/' + underKlassePartiId ,{
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'parti-token': partiData.token
                }
            })
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 0) {
                            throw Error("Tjek om du er på internettet og prøv igen");
                        }
                        else if (response.status === 500) {
                            return response.json() // return the result of the inner promise, which is an error
                                .then((json) => {
                                    throw new Error(json);
                                });
                        }
                        else {
                            throw Error("Det er sket en fejl. Prøv igen.");
                        }
                    }
                    else {
                        return response.json().then(resolve)
                    }
                })
                .catch(reject);
        });

    }

    function checkInDelKlasseParti(partiData) {
        return new Promise((resolve, reject)=>{
            window.fetch(url + '/' + partiData.proeveId + '/parti/' + partiData.partiId + '/checkInDelKlasseParti' ,{
                method: "PUT",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'parti-token': partiData.token
                }
            })
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 0) {
                            throw Error("Tjek om du er på internettet og prøv igen");
                        }
                        else if (response.status === 500) {
                            return response.json() // return the result of the inner promise, which is an error
                                .then((json) => {
                                    throw new Error(json);
                                });
                        }
                        else {
                            throw Error("Det er sket en fejl. Prøv igen.");
                        }
                    }
                })
                .then(resolve)
                .catch(reject);
        });
    }

    function getUnderKlassePartierFromServer(proeveId, partiId, token) {
        var ret =  url + '/' + proeveId + '/parti/' + partiId + '/underKlassePartier';
        return new Promise((resolve, reject)=>{
            window.fetch(ret ,{
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'parti-token': token
                }
            })
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 0) {
                            throw Error("Tjek om du er på internettet og prøv igen");
                        }
                        else if (response.status === 500) {
                            return response.json() // return the result of the inner promise, which is an error
                                .then((json) => {
                                    throw new Error(json);
                                });
                        }
                        else {
                            throw Error("Det er sket en fejl. Prøv igen.");
                        }
                    } else {
                        return response.json().then(resolve)
                    }
                })
                .catch(reject);
        });
    }

    function checkOutPartiFromServer(proeveId, passord, partiId) {
        return new Promise((resolve, reject) => {
            window.fetch(url + `/${proeveId}/parti/${partiId}/checkOut`, {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    clientVersion: "3.1",
                    password: passord
                })
            })
                .then((response) => {
                        if (!response.ok) {
                            if (response.status === 423) {
                                throw Error("Prøven er ikke åbnet for brug av Lydighed program. Åbnes ved å sette ring passord i Prøve systemet.");
                            }
                            else if (response.status === 401) {
                                throw Error("Ugyldig prøveid(REFNR) eller password");
                            }
                            else if (response.status === 409) {
                                throw Error("Du kører fejl versjon. Siden vil automatisk opdatere. Prøv igen når siden er lastet.");
                            }
                            else if (response.status === 500) {
                                console.log(response);
                                return response.json() // return the result of the inner promise, which is an error
                                    .then((json) => {
                                        throw new Error(json);
                                    });
                            }
                            else {
                                throw Error("Det er sket en fejl. Prøv igen.");
                            }
                        }
                        else {
                            return response.json().then(resolve)
                        }
                    })
                .catch(reject);
        });
    }

    function savePartiData(partiData) {
        window.localStorage.removeItem('dkk-proeve-parti-' + process.env.REACT_APP_ENV);
        window.localStorage.setItem('dkk-proeve-parti-' + process.env.REACT_APP_ENV, JSON.stringify(partiData));
        window.localStorage.setItem('dkk-proeve-parti-' + process.env.REACT_APP_ENV + '-id', id + '-' + new Date().getTime());
    }


    function loadPartiData() {
        var s = window.localStorage.getItem('dkk-proeve-parti-' + process.env.REACT_APP_ENV);
        if (s) {
            return JSON.parse(s);
        } else {
            return null;
        }
    }

    function deletePartiData() {
        window.localStorage.removeItem('dkk-proeve-parti-' + process.env.REACT_APP_ENV);
        window.localStorage.setItem('dkk-proeve-parti-' + process.env.REACT_APP_ENV + '-id', id + '-' + new Date().getTime());
    }


    var reloadTimer = null;
    function getReloadTimer() {
        return reloadTimer;
    }

    function setReloadTimer(timer) {
        reloadTimer = timer;
    }



    return {
        getId: getId,
        changeKlasseParti: changeKlasseParti,
        checkOutPartiFromServer: checkOutPartiFromServer,
        checkInToServer: checkInToServer,
        checkInDelKlasseParti: checkInDelKlasseParti,
        checkOutUnderKlasseParti: checkOutUnderKlasseParti,
        savePartiData: savePartiData,
        loadPartiData: loadPartiData,
        deletePartiData: deletePartiData,
        setReloadTimer: setReloadTimer,
        getReloadTimer: getReloadTimer,
        getKlassePartier: getKlassePartier,
        getUnderKlassePartierFromServer: getUnderKlassePartierFromServer
    }
}());




// WEBPACK FOOTER //
// ./src/services/persistService.js